import { Inject, Injectable } from '@angular/core';
import { catchError, Observable, of, filter, switchMap, take, startWith } from 'rxjs';
import { PLACEHOLDER_IMAGE } from '@core/utils/utils';
import { mergeMap, delay} from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { AUTH_SERVICE } from '@core/auth/token';
import { AuthServiceInterface } from '@core/auth/auth.interface'

@Injectable({ providedIn: 'root' })
export class AvatarService {
  constructor(
    private http: HttpClient,
    @Inject(AUTH_SERVICE) private authService: AuthServiceInterface
  ) {}

  public getAvatarImage(filename?: string): Observable<string> {
    if (!filename) {
      return of(PLACEHOLDER_IMAGE);
    }

    const url = `${environment.avatarUrl}/${filename}`;
    return this.http.get(url, { responseType: 'blob' }).pipe(
      switchMap(blob => this.readDataFromURL(blob)),
      catchError(error => {
        console.error(`[AvatarService] Failed to fetch or process avatar from ${url}`, error);
        return of(PLACEHOLDER_IMAGE);
      })
    );
  }

  /**
   * @param response The response coming from the backend
   * @returns The base64 encoded image
   */
  private readDataFromURL = (response: unknown): Observable<string> => {
    return new Observable<string>((subscriber) => {
      const reader = new FileReader();
      reader.readAsDataURL(response as Blob);
      reader.onloadend = () => {
        subscriber.next((reader.result as string).replace('data:application/json;base64,', 'data:image/jpeg;base64,'));
      };
    });
  };
}
